import { FOOTER } from "@/constants/testIds";
import FooterBrand from "@/components/footer/FooterBrand";
import FooterLinks from "@/components/footer/FooterLinks";
import FooterContacts from "@/components/footer/FooterContacts";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-nightsky text-ivory mt-32 overflow-hidden"
    >
      {/* World map background */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        aria-hidden="true"
      >
        <img
          src="/brand/world-map.svg"
          alt=""
          className="w-[120%] max-w-none opacity-[0.07]"
          style={{ filter: "brightness(0) invert(1)" }}
        />
      </div>
      {/* Indigo wash texture */}
      <div
        className="absolute inset-0 opacity-25 mix-blend-soft-light pointer-events-none"
        style={{
          backgroundImage:
            "url('https://static.prod-images.emergentagent.com/jobs/79144187-2235-4ee7-9fa7-a726d5fa0d55/images/ee0826617731e28633def1043fa74b7fe9c94e40a77e7980e7a75dfc35b0424f.png')",
          backgroundSize: "cover",
        }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12">
        <FooterBrand />
        <FooterLinks />
        <FooterContacts />
      </div>

      <div className="relative border-t border-ivory/10">
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] text-ivory/45 font-light">
          <div>© {new Date().getFullYear()} IBNS TRAVELS PVT. LTD. — ALL JOURNEYS, PRIVATELY CRAFTED.</div>
          <div className="tracking-widest2 uppercase text-[10px]">India · Nepal · Bhutan · Sri Lanka</div>
        </div>
      </div>
    </footer>
  );
}
